export function formatCurrencyTotal(currency) {
  var dvalue = Math.round(currency * 10) / 10;
  return `${dvalue.toFixed(2)}`;
}

export function formatMoney(number) {
  var formatter = new Intl.NumberFormat("no-NB", {
    style: "currency",
    currency: "NOK",
  });

  return formatter.format(number);
}

export function formatCurrency(currency) {
  var dvalue = Math.round(currency * 100) / 100;
  return `${dvalue.toFixed(2)}`;
}

export function formatWithoutCurrency(currency) {
  var dvalue = Math.round(currency * 100) / 100;
  return `${dvalue.toFixed(2)}`;
}

export function sameValue(val1, val2) {
  const strA = JSON.stringify(val1);
  const strB = JSON.stringify(val2);
  return strA === strB;
}

export function serializeToQueryParams(obj) {
  for (let prop in obj) {
    if (obj[prop] === undefined || obj[prop] === null || obj[prop] === "") {
      delete obj[prop];
    }
  }

  return "?" + new URLSearchParams(obj).toString();
}

export function setFavicon(file) {
  file = file ?? "favicon.ico";

  const favicon = document.getElementById("favicon");
  if (!favicon) {
    return;
  }

  favicon.href = `${window.location.origin}/${file}`;
  console.log("set favicon ", favicon.href);
}

export function getRouteQueryParam(route, querykey, fallback) {
  var value = route?.query?.[querykey];
  if (value) {
    value = JSON.parse(value);
    return value;
  }

  return fallback;
}

export function validateUpdate(update) {
  return update && (!Array.isArray(update) || update.some((x) => x !== undefined && x !== null));
}

export function setRouteQueryParam(router, route, querykey, update) {
  if (!router || !route) {
    return;
  }

  router.replace({
    query: {
      ...route.query,
      [querykey]: validateUpdate(update) ? JSON.stringify(update) : undefined,
    },
  });
}

export function resolveRouteDisplayName(route, translate) {
  if (!route?.meta) {
    return "";
  }

  if (route.meta.displayNameKey && typeof translate === "function") {
    return translate(route.meta.displayNameKey);
  }

  return route.meta.displayName ?? "";
}

export function statuscolor(statusid) {
  switch (statusid) {
    case 5:
      return "jobstatus_forecast_color";
    case 10:
      return "jobstatus_new_color";
    case 20:
      return "jobstatus_planned_color";
    case 25:
      return "jobstatus_drive_color";
    case 30:
      return "jobstatus_in_progress_color";
    case 40:
    case 45:
      return "jobstatus_waiting_color";
    case 50:
      return "jobstatus_completed_color";
    case 60:
      return "jobstatus_warranty_color";
    case 70:
      return "jobstatus_approved_color";
    case 100:
      return "jobstatus_closed_color";
    case 110:
      return "error";
    default:
      return "disabled";
  }
}

export function machineGeneralizerText(machine) {
  var text = "";
  if (machine) {
    var model = machine.MachineModel;
    if (model) {
      if (model.MachineType) {
        text = model.MachineType.Name + " ";
      }
      text = text + model.Name;
    } else {
      text = text + [machine.MachineType, machine.MachineModelName].join(" ");
    }
  }

  return text;
}

export function machineIdentifierText(machine) {
  var text = "";
  if (machine) {
    text = text + machine.Name;
    if (machine.SerialNumber || machine.Qrcode) {
      text = text + " [";
      if (machine.SerialNumber) {
        text = text + machine.SerialNumber;
      }
      if (machine.SerialNumber && machine.Qrcode) {
        text = text + ", ";
      }
      if (machine.Qrcode) {
        text = text + machine.Qrcode;
      }
      text = text + "]";
    }
  }

  return text;
}

export function isUltrawideBreakpoint(display) {
  return Boolean(display?.xlAndUp);
}

export function isPcBreakpoint(display) {
  return Boolean(display?.lgAndUp);
}

export function isMediumUpBreakpoint(display) {
  return Boolean(display?.mdAndUp);
}

export function isPadBreakpoint(display) {
  return Boolean(display?.mdAndDown);
}

export function isPhoneBreakpoint(display) {
  return Boolean(display?.xs);
}

export function getThemeColor(vuetify, colorName, fallback = "") {
  return vuetify?.theme?.current?.colors?.[colorName] ?? fallback;
}